import { render, staticRenderFns } from "./JoinUsMain.vue?vue&type=template&id=691ba9ee&"
import script from "./JoinUsMain.vue?vue&type=script&lang=js&"
export * from "./JoinUsMain.vue?vue&type=script&lang=js&"
import style0 from "./JoinUsMain.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/ctweb/fontend/kecc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('691ba9ee')) {
      api.createRecord('691ba9ee', component.options)
    } else {
      api.reload('691ba9ee', component.options)
    }
    module.hot.accept("./JoinUsMain.vue?vue&type=template&id=691ba9ee&", function () {
      api.rerender('691ba9ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DefaultHome/KECC/AboutUs/JoinUs/JoinUsMain.vue"
export default component.exports